import { PureComponent } from 'react';
import PropTypes from 'prop-types';
class ErrorBoundary extends PureComponent {
  static propTypes = {
    children: PropTypes.oneOfType([PropTypes.node.isRequired])
  };
  static getDerivedStateFromError = () => ({
    isError: true
  });
  state = {
    isError: false
  };
  componentDidCatch = ({
    message
  }, {
    componentStack
  }) => {
    console.error(message);
    console.error(componentStack);
  };
  render = () => {
    const {
      isError
    } = this.state;
    return isError ? null : this.props.children;
  };
}
export default Component => props => /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement(Component, props));